module.exports = __webpack_public_path__ + "img/ConditionMonitoring-dark.bfafb15b.svg";